import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { type CSSProperties } from 'react';
import styles from './ProgressBar.module.css';
import useDeltaColor from './useDeltaColor';
type ProgressBarWithPercentage = {
  progressPercentage: number;
  value?: never;
};
type ProgressBarWithValue = {
  progressPercentage?: never;
  value: number;
};
type ProgressBarProps = {
  max?: number;
  progressBackgroundColor?: string;
  progressColor?: string;
  darkMode?: boolean;
  intervalMs?: number;
  min?: number;
  invisibleLabelText?: string;
  valueText?: string;
  id?: string;
  style?: CSSProperties;
} & (ProgressBarWithPercentage | ProgressBarWithValue);
const INTERVAL_MS = 5000;
const DEFAULT_MAX_VALUE = 100;
function ProgressBar(t0) {
  const $ = _c(20);
  const {
    id,
    progressBackgroundColor,
    progressColor,
    intervalMs: t1,
    darkMode,
    value,
    max: t2,
    min: t3,
    invisibleLabelText,
    valueText,
    progressPercentage: progressPercentage_
  } = t0;
  const intervalMs = t1 === undefined ? INTERVAL_MS : t1;
  const max_ = t2 === undefined ? DEFAULT_MAX_VALUE : t2;
  const min = t3 === undefined ? 0 : t3;
  const max = max_ || DEFAULT_MAX_VALUE;
  const progressPercentage = progressPercentage_ ?? value / max * 100;
  const {
    delta,
    deltaColor,
    backgroundColor,
    color
  } = useDeltaColor(progressPercentage, intervalMs, progressColor, progressBackgroundColor, darkMode);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = classNames(styles.progressbar, "progressbar");
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const t5 = `${intervalMs}ms`;
  const t6 = delta / progressPercentage;
  let t7;
  if ($[1] !== backgroundColor || $[2] !== color || $[3] !== deltaColor || $[4] !== t5 || $[5] !== t6) {
    t7 = {
      "--transition-duration": t5,
      "--background-color": backgroundColor,
      "--color": color,
      "--percent-delta": t6,
      "--delta-color": deltaColor
    };
    $[1] = backgroundColor;
    $[2] = color;
    $[3] = deltaColor;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = t7 as CSSProperties;
  let t9;
  if ($[7] !== progressPercentage) {
    t9 = Math.round(progressPercentage);
    $[7] = progressPercentage;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = `${t9}%`;
  let t11;
  if ($[9] !== t10) {
    t11 = <span style={{
      maxInlineSize: t10
    }} />;
    $[9] = t10;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== id || $[12] !== invisibleLabelText || $[13] !== max || $[14] !== min || $[15] !== t11 || $[16] !== t8 || $[17] !== value || $[18] !== valueText) {
    t12 = <div id={id} role="progressbar" aria-valuemin={min} aria-valuemax={max} aria-valuenow={value} aria-valuetext={valueText} aria-label={invisibleLabelText} className={t4} style={t8}>{t11}</div>;
    $[11] = id;
    $[12] = invisibleLabelText;
    $[13] = max;
    $[14] = min;
    $[15] = t11;
    $[16] = t8;
    $[17] = value;
    $[18] = valueText;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
}
export default ProgressBar;